// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202609161007/js/" + chunkId + "." + {"44":"482b18a9","225":"c12bc488","481":"c434ac81","486":"81e05491","770":"15e60403"}[chunkId] + ".0.61240627026365.chunk.js";
};